"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferCapabilitiesResponse = exports.ApprovePayoutOverrides = exports.PendingApprovalsQuery = exports.ApprovePayoutRequest = exports.PayoutApprovalTransport = exports.RequestableNetworkLabels = exports.RequestableNetworks = void 0;
const typebox_1 = require("@sinclair/typebox");
const payment_method_1 = require("../common/payment-method");
/**
 * Payout Approval Transport Types
 *
 * Used for managing the approval workflow for vendor payouts that exceed
 * the auto-approval threshold.
 */
// Status enums
const ApprovalStatus = typebox_1.Type.Union([
    typebox_1.Type.Literal('PENDING_APPROVAL'),
    typebox_1.Type.Literal('APPROVED'),
    typebox_1.Type.Literal('REJECTED'),
]);
const PaymentMethod = typebox_1.Type.Literal('ACH'); // VCC disabled for now
// Requestable transfer networks (excludes 'wire' which is read-only/historical)
exports.RequestableNetworks = ['ach', 'same-day-ach', 'rtp'];
const RequestableNetworkSchema = typebox_1.Type.Union(exports.RequestableNetworks.map((n) => typebox_1.Type.Literal(n)));
exports.RequestableNetworkLabels = {
    ach: 'Standard ACH (2-3 days)',
    'same-day-ach': 'Same-Day ACH',
    rtp: 'RTP (Instant)',
};
// Main transport schema
exports.PayoutApprovalTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    invoiceID: typebox_1.Type.String({ format: 'uuid' }),
    payableID: typebox_1.Type.String({ format: 'uuid' }),
    amount: typebox_1.Type.Integer({ minimum: 0 }),
    requestedPaymentMethod: PaymentMethod,
    status: ApprovalStatus,
    requestedBy: typebox_1.Type.String({ format: 'uuid' }),
    reviewedBy: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    reviewedAt: typebox_1.Type.Optional(typebox_1.Type.String()), // ISO 8601 timestamp
    rejectionReason: typebox_1.Type.Optional(typebox_1.Type.String()),
    autoApproved: typebox_1.Type.Boolean(),
    approvalThreshold: typebox_1.Type.Integer({ minimum: 0 }),
    // Computed flags
    isPending: typebox_1.Type.Boolean(),
    isOverdue: typebox_1.Type.Boolean(),
    // Entity metadata
    metadata: typebox_1.Type.Optional(typebox_1.Type.Any()),
});
// Approve request (for POST /approve)
exports.ApprovePayoutRequest = typebox_1.Type.Object({
    approved: typebox_1.Type.Boolean(),
    rejectionReason: typebox_1.Type.Optional(typebox_1.Type.String()),
    networkOverride: typebox_1.Type.Optional(RequestableNetworkSchema),
    paymentMethodOverride: typebox_1.Type.Optional(payment_method_1.PaymentMethod),
});
// Query parameters for listing pending approvals
exports.PendingApprovalsQuery = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1, maximum: 100 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    minAmount: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    maxAmount: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    paymentMethod: typebox_1.Type.Optional(PaymentMethod),
    requestedBy: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    sortBy: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Literal('amount'), typebox_1.Type.Literal('createdAt')])),
    sortOrder: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Literal('asc'), typebox_1.Type.Literal('desc')])),
});
// Body for POST /payouts/:id/approve (optional overrides for expedited payouts)
exports.ApprovePayoutOverrides = typebox_1.Type.Object({
    networkOverride: typebox_1.Type.Optional(RequestableNetworkSchema),
    paymentMethodOverride: typebox_1.Type.Optional(payment_method_1.PaymentMethod),
});
// Response for GET /transfer-capabilities
exports.TransferCapabilitiesResponse = typebox_1.Type.Object({
    supportedNetworks: typebox_1.Type.Array(RequestableNetworkSchema),
    isACHReady: typebox_1.Type.Boolean(),
    /** True when capabilities could not be fetched from Plaid (supportedNetworks is a fallback) */
    degraded: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
//# sourceMappingURL=payout-approval-transport.js.map